import {
  getRefreshToken,
  VDriveDeliveryEntity,
  vDriveDeliveryStatus,
} from '@vgrubs/components';
import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

const SOCKET_URL = process.env.NX_API_URL;

const useDeliveriesDetailsSocket = ({
  deliveryStatus,
  deliveryId,
  orderId,
  getData,
}: {
  deliveryStatus: vDriveDeliveryStatus | undefined;
  deliveryId?: string;
  orderId?: string;
  getData: (noLoader?: boolean) => void;
}) => {
  const refreshToken = getRefreshToken();
  const socketRef = useRef<any>(null);
  const deliveryStatusRef = useRef(deliveryStatus);

  // keep ref updated on each render
  useEffect(() => {
    deliveryStatusRef.current = deliveryStatus;
  }, [deliveryStatus]);

  useEffect(() => {
    if (!refreshToken) return;
    if (!deliveryId && !orderId) return;

    if (socketRef.current && socketRef.current.connected) {
      return;
    }

    const socket = io(SOCKET_URL, {
      path: '/delivery',
      transports: ['websocket'],
      auth: {
        authorization: refreshToken,
      },
    });

    socketRef.current = socket;

    socket.on('connection_successful', () => {
      socket.emit('observe-single-delivery', {
        subscribe: true,
        deliveryId: deliveryId || undefined,
        orderId: orderId || undefined,
      });
    });

    socket.on('update_single_delivery', (data: VDriveDeliveryEntity) => {

      if (data.status !== deliveryStatusRef.current) {
        getData(true);
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [refreshToken, deliveryId, orderId]);

  return {};
};

export default useDeliveriesDetailsSocket;
